import styled, { css } from 'styled-components';
import { COLOURS, hasAlignment, media, mediaMap, shouldForwardProp, spacingMixin } from '@belong/themes';
import { StyledCSS } from '@belong/types';
import { LONG_SPACING, SHORT_SPACING } from './contentFormatter.config';
import { IContentFormatter } from './ContentFormatter.types';

const shortSpacing = (spacing): StyledCSS<any> => css`
  ${hasAlignment};

  & > * + * {
    ${mediaMap(
      SHORT_SPACING[spacing],
      (margin: string) => css`
        margin-top: ${margin};
      `
    )}
  }
`;

const longSpacing = (): StyledCSS<any> => css`
  hr {
    margin: 4rem 0;

    ${media('md')`
      margin: 4.8rem 0;
    `}

    /**
     * It appears that a <hr> as the last item in a Rich Text
     * block doesn't get its margins collapsed into the subsequent <section>'s
     * margin-top. So let's make sure this hr doesn't push down then.
     */
    &:last-child {
      margin-bottom: 0;
    }
  }
  ${Object.keys(LONG_SPACING).map(target =>
    Object.keys(LONG_SPACING[target]).map(sibling => {
      return css`
        ${target} + ${sibling} {
          ${mediaMap(
            LONG_SPACING[target][sibling],
            (margin: string) => css`
              margin-top: ${margin};
            `
          )}
        }
      `;
    })
  )}
`;

export const Wrapper = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp<IContentFormatter>('spacing')
})<IContentFormatter>`
  hr {
    border-top: 1px solid ${COLOURS.GREY_300};
    border-bottom: none;
  }
  ${spacingMixin}

  /**
   * We need to ensure if the last paragraph, if empty, is not displayed so we don't have extra spacing at the bottom
   * of the content block, this is especially important when diplaying ul/ol as in contentful, we cannot avoid adding a 
   * new paragraph after the element, the RichText does not allow for this so we have to do it manually here
   */
  & > p:last-child:empty {
    display: none;
  }

  ${({ contentLength, spacing }): StyledCSS<IContentFormatter> =>
    contentLength === 'short' ? shortSpacing(spacing) : longSpacing()};
`;
